import { z } from '@tasama/utils';

export const getBusinessActivitiesSchema = (t: (_key: string) => string) =>
  z.object({
    selectedActivityIds: z
      .array(z.string())
      .min(1, t('businessActivities.validation.required')),
  });

export const businessActivitiesSchema = getBusinessActivitiesSchema(
  (key) => key
);

export type BusinessActivitiesFormValues = z.infer<
  typeof businessActivitiesSchema
>;

export const businessActivitiesDefaultValues: BusinessActivitiesFormValues = {
  selectedActivityIds: [],
};
